jQuery(document).ready(function($) {
	

	/* Popup */

	$('.jsFavPop a').click(function(event) { 
		event.preventDefault();
		if ( !$('.login_popup .inq_info_text').length ) {
			var the_title = $('.page-title').html();
			$('.login_popup').prepend('<div class="inq_info_text"> To inquire about this bag you must be logged in, please login or create a free account to view the price of this <strong>'+ the_title +'</strong>.</div>')
		}
		$('.login_popup_layer, .login_popup').fadeIn();
		socialLogin.set_redirect_login_url(window.location.href);
		var form_url =  window.location.href; 
		$("#redirect_url").val(form_url);

		var return_to = window.location.pathname;
		$("#return_to").val(return_to);
	});

	$('.js_OpenLogin').click(function(event) { 
		event.preventDefault();
		$('.login_popup_layer, .login_popup').fadeIn();
		socialLogin.set_redirect_login_url(window.location.href)
	});


	$('.jsGoFav, .favorite-title > a').click(function(event) {
		event.preventDefault();
		$('body').addClass('loader');
		location.href = $(this).attr('href');
	});

	if(window.location.hash) {
	  // console.log('has hash')
	  var hash = location.hash.substr(1);
	    // console.log()
	    if (hash == 'wishlist' ) {
	    	var the_id = Cookies.get('wish_id');
	    	var need_button = $('#wish_' + the_id);
	      // console.log(the_id);
	      if (need_button.hasClass('add_favorite')) {
	      	need_button.click();
	      }
	    }
	  }

	  $('.q_pop_wrap > .q_pop_layer, .q_pop_close').click(function(event) {
	  	event.preventDefault();
	  	$(this).closest('.q_pop_wrap').fadeOut();
	  
	  });



	  function menu(){
	  	var action_link = $('.dropdown > a');

	  	action_link.click(function(event) {
	  		event.preventDefault();
	  		var need_block = $(this).next('ul');
	  		var sub_height = $(this).next('ul').outerHeight();
	  		if (need_block.is(':visible')) {
	  			need_block.fadeOut('fast');
	  			$('.menu_layer').fadeOut('fast');
	  		}
	  		else{
	  			$('.sub-nav').hide();
	  			need_block.fadeIn('fast');
	  			$('.menu_layer').css('height', sub_height).fadeIn('fast');
	  		}
	  	});
	  }

	  function mobile_menu(){
	  	$('.jsOpenMobile')	.click(function(event) {
	  		event.preventDefault();
	  		$('.head_menublock').toggle();
	  	});
	  	$('.nav-item.dropdown > a').click(function(event) {
	  		event.preventDefault();
	  		$(this).parent('.dropdown').siblings('.dropdown').find('.sub-nav').slideUp('fast');
	  		$(this).next('.sub-nav').slideToggle('fast');
	  	});
	  	$('.sub_title').click(function(event) {
	  		event.preventDefault();
	  		$(this).next('ul').slideToggle('fast');
	  		$(this).closest('.dropdown').siblings('.dropdown').children('.sub_title').next('ul').slideUp('fast');
	  		$(this).closest('.sub_box').siblings('.sub_box').children('.sub_title').next('ul').slideUp('fast');
	  	});
	  }

	  function check_mobile(){
	  	if ($(window).width() >= 769) {
	  		menu();
	  	}	
	  	else{
	  		mobile_menu();
	  	}
	  }
	  check_mobile();

	  function collection_dropdowns(){
	  	var col_item = $('.sort_list li a');
	  	col_item.click(function(event) {
	  		event.preventDefault();
	  		var col_url = '/collections/' +$(this).attr('class').replace(/\s/g, '/').replace(/\_/g, '+');
	      // console.log(col_url);
	      window.location = col_url;
	    });
	  }
	  collection_dropdowns()

	  if ($('body').hasClass('template-collection')) {
	  	function moveScroller() {
	  		var $anchor = $("#anchor");
	  		var $scroller = $('#filter_section');

	  		var move = function() {
	  			var st = $(window).scrollTop();
	  			var ot = $anchor.offset().top;
	  			if(st > ot) {
	  				$scroller.css({
	  					position: "fixed",
	  					top: "0px"
	  				}).addClass('fix')
	  			} else {
	  				if(st <= ot) {
	  					$scroller.css({
	  						position: "relative",
	  						top: ""
	  					}).removeClass('fix')
	  				}
	  			}
	  		};
	  		$(window).scroll(move);
	  		move();
	  	}

	  	$(function() {
	  		moveScroller();
	  	}); 
	  }


	  if ($(window).width() <= 768) {
	  	$('.jsMobileFoot').click(function(event) {
	  		event.preventDefault();
	  		$(this).next('nav').slideToggle();
	  		$(this).find('i').toggleClass('fa-angle-down fa-angle-up');
	  		$(this).closest('.jsFootMenu').siblings('.jsFootMenu').find('nav').slideUp();
	  		$(this).closest('.jsFootMenu').siblings('.jsFootMenu').find('i').removeClass(' fa-angle-up').addClass('fa-angle-down');
	  	});

	  	$('.jsOpenFilters, .jsMobileFilterClose').click(function(event) {
	  		event.preventDefault();
	  		$('.jsMobileFilter').toggleClass('shown');
		  	// $('body').toggleClass('ovh');
		  });
	  }

	  $(window).resize(function() {
	  	if($(this).width() > 768) {
	  		$('.jsFootMenu').find('nav').show();
	  		$('.jsMobileFilter').show();
	  	}
	  });


jQuery('body').bind('focusin focus', function(e){
  e.preventDefault();
})


	});
